module.exports = __webpack_public_path__ + "static/media/InconsolataRegular.1117ffb0.ttf";